import React, { useState, useEffect } from 'react';
import axios from "axios";
import { useParams } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const SchoolHeroPage = () => {
  const { school_slug } = useParams();
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const fallbackImage = `${baseAPIUrl}assets/images/home-page/image.jpg`;
  const alt = `TIGPS-${school_slug}-Video`;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  /* ---------------- FETCH DATA ---------------- */

  useEffect(() => {
    if (!school_slug) return;

    axios.get(
      `${baseAPIUrl}api/general_settings/get_general_settings/${school_slug}`
    )
      .then(res => {
        if (res.data.status === 1) {
          setInfo(res.data.data.settings);
        }
      })
      .catch(err => console.error("CONTACT API ERROR:", err))
      .finally(() => setLoading(false));
  }, [school_slug]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const videoUrl = info?.school_video
    ? `${baseAPIUrl}assets/images/settings/${info.school_video}`
    : null;

  return (
    <section
      style={{
        position: 'relative',
        width: '100%',
        height: isMobile ? 'auto' : '75vh',
        minHeight: isMobile ? '0' : '650px',
        maxHeight: isMobile ? 'none' : '850px',
        overflow: 'hidden'
      }}
    >
      {videoUrl ? (
        <video
          key={videoUrl}   // 👈 IMPORTANT: forces reload
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          poster={fallbackImage}
          controls={false}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
        >
          <source src={videoUrl} type="video/mp4" />
        </video>
      ) : (
        <img
          src={fallbackImage}
          alt={alt}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
        />
      )}
    </section>
  );
}

export default SchoolHeroPage;
